<template>
  <div>
    <article-center-detail
      v-if="cardData.length === 1"
      :id="cardData[0].id"
      :typeData="2"
      ref="articleCenterDetail"
    />
    <div v-else>
            <el-card v-for="(item,index) in cardData" :key="index" class="contentBox" >  
              <div class="artic_card" @click="navgateTo(item)">
                <img class="artic_img" src="@/assets/images/pilotService/chakan.png" />
                <div class="artic_title">{{item.title}}</div>
              </div>    
            </el-card>
    </div>
  </div>
</template>

<script>
import { getIndex } from "@/api/acticle/acticle";
import articleCenterDetail from "../pilotService/articleCenter/articleCenterDetail.vue";
export default {
  components: { articleCenterDetail },
  data() {
    return {
      cardData: [],
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      getIndex({ id: 3015 })
        .then((res) => {
          if (res.code == 0) {
            this.cardData = res.data.data;
            
          }
        })
        .catch((err) => {
          ;
        });
    },
    navgateTo(item){
      this.cardData=[]
      this.cardData.push(item)
    }
  },
};
</script>

<style scoped>
.contentBox {
  margin: auto;
  position: relative;
  margin-bottom: 25px;
}
.artic_card{
  display: flex;
  align-items: center;
  cursor: pointer;
}
.artic_img{
  width: 24px;
  height: 24px;
  box-sizing: border-box;
}
.artic_title{
  padding: 0px 10px 0px 10px;
  font-weight: 900;
  color: #333333;
  text-align: left;
  line-height: normal;
}
@media only screen and (max-width: 768px) {
  .content {
    margin-top: 10px;
    font-size: 14px;
  }
  .in {
    display: block;
  }
  .boxImg {
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>